import React, { useCallback, useMemo, useRef } from "react";
import { Button, Form, LoadIndicator, Popup, } from "devextreme-react";
import { useEffect, useState } from "react";
import { GroupItem, Label, RequiredRule, SimpleItem } from "devextreme-react/cjs/form";
import { ToolbarItem } from "devextreme-react/cjs/popup";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../api/useAxios";

export function EmployeeDocumentCardMultiAdd({ visible, onHiding, employeeId }) {

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [documentTypes, setDocumentTypes] = useState([])
    const [sendCount, setSendCount] = useState(0)

    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const onHandleFileSelect = (e: React.FormEvent<HTMLInputElement>) => {
        const files = e.currentTarget.files;
        if (files) {
            setSelectedFiles(Array.from(files));  // FileList'i diziye dönüştürüyoruz
        }
    }
    const handleSaveButtonClick = useCallback(() => {
        setSendCount(sendCount + 1)
        console.log(sendCount)
    }, [sendCount, setSendCount])

    const getSaveButtonOptions = useCallback(() => ({
        text: "Tümünü Kaydet",
        icon: "save",
        onClick:  handleSaveButtonClick 
    }), [handleSaveButtonClick])

    //    useEffect(() => { console.log(selectedFiles) }, [selectedFiles])

    useEffect(() => {
        axiosPrivate.get("/api/EmployeeDocumentInfo")
            .then((response) => {
                //console.log(response)
                if (response?.data) { setDocumentTypes(response.data) }
            })

    }, [axiosPrivate])

    return (
        <Popup
            showTitle
            title="Toplu Belge Kayıt"
            visible={visible}
            onHiding={onHiding}
            hideOnOutsideClick={true}
            defaultWidth={600}
            defaultHeight={500}
        >
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getSaveButtonOptions()}
            />
            <div >
                <input
                    type="file"
                    multiple={true}
                    onChange={onHandleFileSelect}
                />
            </div>

            {selectedFiles.length > 0 &&
                <div style={{ marginTop: "10px" }}>
                    {
                        selectedFiles.map((file, index) => (
                            //<FileUploadPanel file={file} key={index} />
                            <FileUploadPanelForm
                                file={file}
                                key={index}
                                documentTypes={documentTypes}
                                employeeId={employeeId}
                                sendCount={sendCount} />
                        ))
                    }
                </div>
            }
        </Popup>
    )
}

function FileUploadPanelForm({ file, documentTypes, employeeId, sendCount }) {

    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)

    const formRef = useRef(undefined)
    const [sending, setSending] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [formData, setFormData] = useState({
        employeeDocumentInfoId: undefined,
        description: file.name,
    })

    const documentTypesOptions = useMemo(() => (
        {
            items: documentTypes,
            valueExpr: "id",
            displayExpr: "name"
        }
    ), [documentTypes])

    const handleSubmit = useCallback(async (e) => {

        if (!formRef.current.instance.validate().isValid)
            return;

        const data = new FormData()
        data.append("employeeId", employeeId)
        data.append("employeeDocumentInfoId", formData.employeeDocumentInfoId)
        data.append("description", formData.description)
        data.append('file', file);

        const axiosOptions = {
            method: formData.id ? "put" : "post",
            url: "/api/EmployeeDocument/FormData",
            data: data
        }

        try {
            setError(false)
            setSending(true)
            const response = await axiosPrivate(axiosOptions)

            if (response?.status === 201 || response?.status === 200) {
                setSuccess(true)
            }
        } catch (error) {
            setError(true)
        } finally {
            setSending(false)
        }

    }, [formData, axiosPrivate, employeeId, file])


    useEffect(() => {
        if (sendCount > 0)
            if (!sending && !error && !success)
                handleSubmit(undefined)

    }, [sendCount, sending, error, success, handleSubmit])

    useEffect(()=>(console.log("panel-sendCount",sendCount)),[sendCount])

    if (!employeeId)
        return <>EmployeeId is empity</>

    return (
        <div>
            <Form
                style={{ padding: "10px" }}
                labelMode="floating"
                formData={formData}
                disabled={success}
                ref={formRef}
            >
                <GroupItem colCount={7} alignItemLabels={true}>
                    <SimpleItem
                        dataField="description"
                        helpText={file.name}
                        colSpan={4}
                    >
                        <Label text="Dosya Açıklaması" />
                        <RequiredRule />
                    </SimpleItem>
                    <SimpleItem
                        dataField="employeeDocumentInfoId"
                        colSpan={2}
                        editorType="dxSelectBox"
                        editorOptions={documentTypesOptions}
                    >
                        <Label text="Döküman tipi" />
                        <RequiredRule />
                    </SimpleItem>

                    <GroupItem >
                        <Button
                            visible={!sending}
                            icon={success ? "check" : error ? "errorcircle" : "save"}
                            type={success ? "success" : error ? "danger" : "default"}
                            onClick={handleSubmit}
                        />

                        <LoadIndicator visible={sending} />

                    </GroupItem>
                </GroupItem>
            </Form>
        </div>

    )
}
